import { useClient } from '@/composables/useClient'
import type { ApiResponsePromise } from '@/types/general'
import { type ErrorResponse } from '@repo/api-contracts'
import type { GroupedProducts, MealRecommendationsResult } from '@repo/api-types'

export const useProducts = () => {
  const getProducts = async (): Promise<{
    error?: string | null
    products?: GroupedProducts
  }> => {
    const client = await useClient()

    const { status, body } = await client.product.getProducts()

    if (status === 200) {
      return { products: body }
    }

    const { error } = body as ErrorResponse

    return {
      error: error || 'Unexpected server error',
    }
  }

  const getMealRecommendations = async (animalId: string): ApiResponsePromise<MealRecommendationsResult> => {
    const client = await useClient()

    const { status, body } = await client.product.getMealRecommendations({
      params: {
        animalId,
      },
    })

    if (status === 200) {
      return { result: body }
    }

    const { error } = body as ErrorResponse

    return {
      error: error || 'Unexpected server error',
    }
  }

  return {
    getProducts,
    getMealRecommendations,
  }
}
